import { Logger as beaverLogger } from '@krakenjs/beaver-logger'

const logger = beaverLogger({
  url: '/shopping/rest/log'
})

export default logger
